var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassroomPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(-436 -221)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    transform: "translate(436 221)",
    fill: "#96999c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(458.626 245.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M356.754,218.345c-1.037.009-2.074.016-3.111.029-.232,0-.335-.093-.333-.329q.009-1.066,0-2.133c0-.236.1-.331.333-.329,1.037.013,2.074.02,3.111.029Z",
    transform: "translate(-313.006 -190.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M53.724,0H70.842c.664,0,.664,0,.664.681q0,7.577,0,15.154c0,.616,0,.617-.6.617-1.039,0-2.078-.01-3.116.005-.331,0-.457-.1-.446-.441.02-.64,0-1.281.009-1.921.005-.271-.087-.38-.369-.379q-3.031.011-6.062,0c-.26,0-.352.1-.348.355.01.64-.013,1.281.008,1.921.012.353-.114.467-.466.465-2.22-.012-4.44-.006-6.659-.006h-16.9c-.626,0-.627,0-.627-.633q0-7.6,0-15.2c0-.622,0-.623.637-.623H53.724",
    transform: "translate(-31.828 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M53.617,158.424H36.5c-.628,0-.628,0-.629-.631,0-.569.017-1.139-.006-1.707-.015-.361.129-.493.473-.454a2.657,2.657,0,0,0,.3,0H70.7c.142,0,.285.007.427,0,.235-.01.332.1.33.332q-.008,1.067,0,2.134c0,.24-.11.333-.338.323-.142-.006-.285,0-.427,0H53.617",
    transform: "translate(-31.776 -137.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M47.41,197.6c1.138,0,2.277,0,3.415,0a2.009,2.009,0,0,1,2.047,2.054c0,.939.006,1.879,0,2.818a2,2,0,0,1-2,2.013q-3.5.011-7,0a2,2,0,0,1-1.981-1.989q-.013-1.451,0-2.9a2.005,2.005,0,0,1,1.979-1.992c1.181-.009,2.362,0,3.544,0",
    transform: "translate(-37.104 -175.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M250.973,204.487c-1.138,0-2.277,0-3.415,0a2.01,2.01,0,0,1-2.06-2.041q-.008-1.409,0-2.818a2.007,2.007,0,0,1,2.03-2.027q3.458-.008,6.916,0a2,2,0,0,1,2.038,2.019q.01,1.43,0,2.86a2.005,2.005,0,0,1-2.008,2.006c-1.167.008-2.334,0-3.5,0",
    transform: "translate(-217.489 -175.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M42.006,272.3c-1.878,0-3.757-.011-5.635.009-.419,0-.544-.136-.524-.539.029-.582.026-1.167,0-1.749-.016-.379.1-.54.5-.518.568.03,1.14-.022,1.706.017.45.031.56-.141.54-.561-.032-.681,0-1.366-.014-2.048-.009-.336.081-.49.451-.48,1.154.031.961-.129.978.97.009.569.012,1.139,0,1.707-.007.285.077.411.385.407,1.1-.013,2.191-.011,3.287,0,.275,0,.38-.094.376-.372-.012-.768,0-1.537-.007-2.3,0-.289.094-.409.394-.4,1.243.022,1.01-.14,1.032,1,.011.569.011,1.138,0,1.707-.006.276.094.381.373.376.654-.012,1.309.005,1.963-.007.29-.005.41.095.4.394-.014.64-.023,1.281,0,1.921.015.378-.119.489-.49.486-1.907-.015-3.813-.007-5.72-.007",
    transform: "translate(-31.756 -236.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M245.591,272.312c-1.878,0-3.756-.01-5.635.008-.395,0-.524-.124-.507-.513.027-.6.029-1.2,0-1.792-.021-.406.14-.515.519-.5.6.024,1.2-.011,1.792.013.346.014.443-.118.435-.447-.019-.739.005-1.48-.01-2.219-.006-.317.113-.424.424-.418,1.2.024.984-.134,1,.985q.015.854,0,1.707c-.005.262.067.392.359.389q1.665-.016,3.329,0c.292,0,.362-.128.358-.389-.01-.754.006-1.508-.007-2.262-.005-.3.088-.437.412-.43,1.211.024,1-.131,1.015.973.01.555.017,1.111,0,1.665-.012.329.088.46.435.447.6-.024,1.2.011,1.792-.013.379-.015.539.095.519.5-.03.6-.027,1.2,0,1.792.017.388-.113.516-.507.512-1.906-.017-3.813-.008-5.72-.008",
    transform: "translate(-212.133 -236.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M11.916,256.9c0-1.649.01-3.3-.007-4.947,0-.388.114-.523.508-.51,1.074.034.919-.118.922.939.007,3.17-.005,6.34.011,9.51,0,.428-.117.571-.552.555-1.011-.039-.875.1-.88-.9-.007-1.549,0-3.1,0-4.649",
    transform: "translate(-10.55 -222.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M155.633,256.9c0-1.649.011-3.3-.008-4.947,0-.392.121-.52.511-.508,1.062.033.917-.111.919.9q.009,4.755,0,9.51c0,.584,0,.589-.588.585-.948-.006-.832.1-.835-.848-.006-1.564,0-3.127,0-4.691",
    transform: "translate(-137.872 -222.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M216.935,256.921c0,1.663-.009,3.327.007,4.99,0,.382-.1.528-.5.515-1.078-.035-.923.117-.926-.935-.007-3.17,0-6.34-.011-9.51,0-.422.106-.577.548-.559,1.014.04.879-.1.884.894.007,1.535,0,3.071,0,4.606",
    transform: "translate(-190.918 -222.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M360.654,256.921c0,1.663-.009,3.327.007,4.99,0,.382-.1.528-.5.515-1.078-.035-.924.117-.926-.935-.007-3.17,0-6.34-.011-9.51,0-.422.106-.577.548-.559,1.015.04.879-.1.884.894.007,1.535,0,3.071,0,4.606",
    transform: "translate(-318.243 -222.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M1.737,218.37c-.469,0-.937,0-1.406,0-.233,0-.333-.1-.331-.33q.008-1.065,0-2.13c0-.233.1-.332.331-.33q1.406.007,2.811,0c.233,0,.333.1.331.33q-.008,1.065,0,2.13c0,.233-.1.334-.331.33-.468-.007-.937,0-1.406,0",
    transform: "translate(0 -190.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M151.4,218.343c-.44,0-.881-.01-1.32,0-.285.009-.412-.088-.406-.39.014-.667.013-1.335,0-2-.005-.286.089-.409.391-.405.894.012,1.789.011,2.683,0,.285,0,.412.088.406.39-.014.667-.017,1.335,0,2,.009.329-.137.416-.435.405-.44-.015-.88,0-1.32,0",
    transform: "translate(-132.599 -190.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M205.317,218.352c-.454,0-.909-.009-1.363,0-.275.007-.378-.1-.374-.377q.016-1.022,0-2.045c0-.275.107-.376.378-.373q1.363.013,2.726,0c.275,0,.378.1.374.377q-.015,1.022,0,2.045c0,.275-.106.38-.378.373-.454-.012-.909,0-1.363,0",
    transform: "translate(-180.357 -190.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M265.546,133.131c-.568,0-1.136-.008-1.7,0-.271.005-.381-.1-.378-.373.017-1.269-.133-1.034.973-1.051.923-.014,1.845.006,2.768-.007.31,0,.428.1.422.418-.024,1.2.131.988-.975,1.01-.369.007-.738,0-1.107,0Z",
    transform: "translate(-233.41 -116.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M49.282,331.42c0,.554-.008,1.107,0,1.661,0,.263-.079.391-.364.387-1.289-.018-1.042.142-1.06-1.006-.014-.894.008-1.789-.008-2.683-.006-.338.087-.486.452-.476,1.152.03.958-.129.977.967.007.383,0,.766,0,1.15",
    transform: "translate(-42.394 -291.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M121.144,331.42c0,.525-.015,1.051.005,1.576.013.339-.086.486-.452.476-1.152-.03-.963.129-.976-.967-.011-.908.009-1.817-.008-2.725-.006-.338.087-.486.452-.476,1.152.03.958-.129.977.967.007.383,0,.766,0,1.15",
    transform: "translate(-106.057 -291.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M252.885,331.42c0,.554-.008,1.107,0,1.661,0,.263-.079.391-.364.387-1.289-.018-1.042.142-1.06-1.006-.014-.894.008-1.789-.008-2.683-.006-.338.087-.486.452-.476,1.152.03.958-.129.977.967.007.383,0,.766,0,1.15",
    transform: "translate(-222.771 -291.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M324.751,331.4c0,.568-.008,1.136,0,1.7.005.27-.1.382-.372.379-1.277-.018-1.034.142-1.052-1.014-.014-.908.006-1.817-.007-2.726,0-.309.1-.429.417-.423,1.2.024.989-.131,1.011.974.007.369,0,.738,0,1.107Z",
    transform: "translate(-286.44 -291.754)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomPlaceholder);
export default __webpack_public_path__ + "static/media/classroom_placeholder.d81c2255981be02a5ea815976cd29f95.svg";
export { ForwardRef as ReactComponent };